import React from 'react';
import { Card, CardContent } from './ui/card';

const carriers = [
  {
    name: 'Verizon',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Verizon_2015_logo_-vector.svg/2560px-Verizon_2015_logo_-vector.svg.png'
  },
  {
    name: 'AT&T',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/AT%26T_logo_2016.svg/2560px-AT%26T_logo_2016.svg.png'
  },
  {
    name: 'T-Mobile',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/T-Mobile_logo.svg/2560px-T-Mobile_logo.svg.png'
  },
  {
    name: 'Simple Mobile',
    logo: 'https://www.simplemobile.com/wps/wcm/connect/simple-mobile-us/9c6a8e9f-6e3c-4b9d-9f3e-8e3e1e3e3e3e/simple-mobile-logo.png'
  },
  {
    name: 'Ultra Mobile',
    logo: 'https://www.ultramobile.com/wp-content/uploads/2020/10/ultra-mobile-logo.png'
  },
  {
    name: 'H2O',
    logo: 'https://www.h2owirelessnow.com/mainControl/images/h2o_logo.png'
  },
  {
    name: 'Cricket Wireless',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cricket_Wireless_logo.svg/2560px-Cricket_Wireless_logo.svg.png'
  },
  {
    name: 'Xfinity Prepaid Internet',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Comcast_Xfinity_logo.svg/2560px-Comcast_Xfinity_logo.svg.png'
  }
];

const PrepaidServicesSection = () => {
  return (
    <section className="relative py-20 px-6 overflow-hidden">
      {/* Dark gradient background - matching hero section */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-700" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-6">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Prepaid Carrier Services
          </h2>
          <div className="w-24 h-1 mx-auto mb-6" style={{ backgroundColor: '#00B3B3' }} />
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Activation, plan setup, payments, and support for all major prepaid carriers
          </p>
        </div>

        {/* Carriers Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
          {carriers.map((carrier, index) => (
            <Card 
              key={index} 
              className="border-0 bg-white/10 backdrop-blur-sm shadow-lg hover:shadow-xl hover:bg-white/20 transition-all duration-300 hover:-translate-y-1 group"
            >
              <CardContent className="p-8 flex items-center justify-center min-h-[120px]">
                <h3 className="text-lg font-bold text-white text-center transition-colors" style={{
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                }}>
                  {carrier.name}
                </h3>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PrepaidServicesSection;
